import styled from "styled-components";
import { Row, Col, Container } from "react-bootstrap";

export const MyCol = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 500px;
    min-height: 50px;
`;

export const MyRow = styled(Row)`
`;

export const ParkBarContainer = styled(Container)`
    box-shadow: 0 4px 10px -2px #E3E3E3;
    background-color: #f0ffec;
    border-radius: 15px;
    width: 37vw;
    min-height: 50px;
    @media screen and (min-width: 1800px) {
        font-size: 17px;
    }
    @media screen and (min-width: 2000px) {
        font-size: 19px;
    }
    @media screen and (max-width: 1700px) {
        font-size: 15px;
    }
    @media screen and (max-width: 1081px) {
        font-size: 11px;
    }
    @media screen and (max-width: 700px) {
        font-size: 8px;
        white-space: normal;
    }
    @media screen and (max-width: 600px) {
        font-size: 7px;
    }
`;

